<template lang="pug">
  section.hero.is-bold.app-navbar
    .hero-head
      nav.nav
        .nav-left
          strong Bienvenido:
          span {{ nombre }}
        .nav-center
          a.nav-item.hero-brand(href='/')
            img(src='/static/logo.png', :alt='empresa_full')
        .nav-right.is-flex
          a.nav-item(@click='logout') Salir
</template>

<script>
  export default {
    name: 'welcome',
    data () {
      return {
        nombre: localStorage.getItem('nombre'),
        empresa: process.env.EMPRESA,
        empresa_full: process.env.EMPRESA_FULL
      }
    },
    methods: {
      logout () {
        console.log('hola:')
        localStorage.setItem('token', '')
        localStorage.setItem('username', '')
        localStorage.setItem('nombre', '')
        localStorage.setItem('email', '')
        window.location.href = '/'
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>

  $yellow = #ffdd57
  $blue = #2366d1

  .app-navbar
    z-index 1024
    margin-bottom 10px  
    position: fixed;
    min-width: 100%;
    box-shadow: 0 2px 3px rgba(17, 17, 17, 0.1), 0 0 0 1px rgba(17, 17, 17, 0.1);

    .nav-right {
      align-items: stretch;
      align-items: stretch;
      flex: 1;
      justify-content: flex-end;
      overflow: hidden;
      overflow-x: auto;
      white-space: nowrap;
    }
    
    .nav-left
      display flex
      align-items center
      padding-left 10px
      span
        padding-left 5px
  
  

</style>



// WEBPACK FOOTER //
// Header_Logged.vue?3dcee200